export default "__VITE_ASSET__CgJx1CLt__"